module.exports = __webpack_public_path__ + "img/employe.86bbc92c.png";